module.exports = __webpack_public_path__ + "img/National_Bank_of_Egypt_Logo.06415a81.png";